"use client";
import { createContext, useState } from "react";

export const VenueContext = createContext({
  venue: {} as Venue.Detail | Venue.List,
  setVenue: (venue: Venue.Detail | Venue.List) => { },
});

interface Props {
  children: React.ReactNode;
  initialData?: Venue.Detail | Venue.List;
}

export const VenueProvider = ({ children, initialData }: Props) => {
  const [venue, setVenue] = useState(initialData);

  const value = {
    venue,
    setVenue,
  };

  return (
    <VenueContext.Provider value={value}>
      {children}
    </VenueContext.Provider>
  );
};
